import React from 'react';
import './tagline.css';

export default (props) => {
    return (
<h1 className="tagline">{props.text}</h1>
    );
}



// WEBPACK FOOTER //
// ./src/components/tagline.js